module.exports = __webpack_public_path__ + "img/t-6.d98de8bd.jpg";